<mat-card appearance="outlined">
  <mat-card-content class="no-title" [formGroup]="imageEditForm">
    <span class="row">
      <mat-form-field #formField>
        <mat-label>{{ "HOME.Dateiname" | translate }} </mat-label>
        <input matInput formControlName="fileName"/>
      </mat-form-field>
    </span> 
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "HOME.Beschreibung" | translate }} </mat-label>
        <input matInput formControlName="description"/>
      </mat-form-field>
    </span>
  </mat-card-content>
  <mat-dialog-actions>
    <button mat-stroked-button class="cancel" (click)="closeDialog()" [innerText] = "'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
	  <button (click)="next()" [innerText]=" 'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
  </mat-dialog-actions>
</mat-card>
